<template>
    <div>
        <v-sheet class="px-6 pt-6">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <!--<v-avatar size="120" class="mr-6">
                        <img
                            class=""
                            src="/img/database.c82dbe43.svg"
                            alt=""
                        />
                    </v-avatar>-->
                    <div class="flex-1">
                        <div class="d-flex align-start justify-space-between">
                            <div class="mb-3">
                                <h5 class="mr-2 mb-0">
                                    {{ title }}                                   
                                </h5>
                                <span></span>                                
                                <p class="text--disabled mb-0">{{ title }}</p>
                            </div>
                            <div>
                                
                            </div>
                        </div>
                        <div class="d-flex mb-2">
                            <p class="ma-0 mr-8">
                                <span class="font-weight-medium">{{ code }}</span
                                >
                                <!-- <span class="body-2 text--disabled"
                                    >Posts</span
                                > -->
                            </p>
                        </div>
                        <!--<p class="text--disabled">
                            {{ contact_name }}
                        </p>-->
                    </div>
                    <div class="flex-1 text-right">
                        <v-btn
                            color="white" 
                            style="color: black;"
                            class="ma-2"                                                        
                            :loading="loadingNearbyPlaces"
                            :disabled="!canFetchNearbyPlaces || loadingNearbyPlaces"
                            @click="fetchNearbyPlaces"
                        >
                            <v-icon class="pr-2">mdi-map-marker-radius</v-icon>
                            Update Nearby Places
                        </v-btn>
                        <v-btn class="ma-2" dark color="success" :loading="loading" @click="save">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-row justify="center">     
            <!-- <v-form  v-model="editFormValid" ref="editForm">        -->
            <v-col cols="10" md="6">
                <e-info-card
                    title="Primary Fields"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <v-form  v-model="editFormValid" ref="editForm">
                            <v-list>
                                <v-list-item>
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->                                                                                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Code" 
                                            v-model="code"
                                            outlined
                                            :readonly="!createMode"   
                                            :validate-on-blur="createMode"
                                            :rules="(createMode ? codeRules : [])"                                       
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Title" 
                                            v-model="title"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-autocomplete 
                                            label="Network"
                                            v-model="network_id"
                                            :items="networkOptions"
                                        ></v-autocomplete>
                                        <!--<v-text-field 
                                            label="Description" 
                                            v-model="description"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />-->
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-autocomplete 
                                            label="Update Sync Type"
                                            v-model="operating_hours_update_type"
                                            :items="['manual', 'auto']"                                            
                                        ></v-autocomplete>
                                        <!--<v-text-field 
                                            label="Description" 
                                            v-model="description"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />-->
                                    </v-list-item-content>                                
                                </v-list-item>


                                
                            </v-list>  
                        </v-form>                      
                    </template>
                </e-info-card>
                <br/>
                 <e-info-card
                    title="Operating Schedule"                    
                >
                    <template slot="basic-info-slot">
                         <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Weekday</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>                                         
                                    <th>&nbsp;</th>             
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(interval, loopindex) in operhours_weekly_schedule" :key="loopindex">
                                    <td><v-select v-model="interval.weekday" :items="['monday','tuesday','wednesday','thursday','friday','saturday','sunday']" ></v-select></td>
                                    <td><MyTimepickerComponent v-model="interval.starttime" ></MyTimepickerComponent>  <!--<v-autocomplete  :items="generateTimeIntervals()" clearable></v-autocomplete>--></td>
                                    <td><MyTimepickerComponent v-model="interval.endtime" ></MyTimepickerComponent> <!--<v-autocomplete v-model="interval.endtime" :items="generateTimeIntervals()" clearable></v-autocomplete>--></td>
                                    <td>
                                        <!--<v-btn icon small @click="viewNetwork(ownet.code)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>-->
                                    </td>
                                </tr>
                            </tbody>
                            
                        </v-simple-table>
                        
                    </template>
                </e-info-card>
            </v-col>
            <v-col cols="10" md="4">
                <e-info-card
                    title="Extra Info"
                    sub-title=""
                >
                    <template slot="basic-info-slot">                        
                        <v-form  v-model="editFormBValid" ref="editFormB">
                            <v-list>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Latitude" 
                                            v-model="latitude"
                                            type="number"
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Longitude" 
                                            v-model="longitude"
                                            type="number"
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Address" 
                                            v-model="address"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Postal Code" 
                                            v-model="tk"
                                            :rules="firstNameRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Country" 
                                            v-model="country"
                                            readonly
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="City" 
                                            v-model="city"
                                            
                                            :validate-on-blur="createMode"

                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Area" 
                                            v-model="area"
                                            
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Municipality" 
                                            v-model="municipality"
                                            
                                            :validate-on-blur="createMode"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>
                                    <div style="text-align: start !important; ">
                                        <pre style="text-align: start !important; ">
                                        {{ displayExtraInfo }}
                                    </pre>                                    
                                    </div>                                    
                                </v-list-item>   
                            </v-list>    
                            </v-form>                    
                    </template>
                </e-info-card>
            </v-col>
            <!-- </v-form> -->
            <v-col cols="10" md="5">
               
            </v-col>
        </v-row>
        <!-- <base-card class="transparent">
            
        </base-card> -->
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            top
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import avatarGroupCard from '@/components/card/AvatarGroupCard';
import EInfoCard from '@/components/card/BasicInfoCard';
import {api} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js"
import MyTimepickerComponent from '@/views/settings/mytimepicker-component.vue';

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Location Edit'
    },
    components: {
        avatarGroupCard,
        EInfoCard,
        MyTimepickerComponent
    },
    data() {
        return {
            //primary data
            code: '',
            title: '',

            address: '',
            tk: '',
            country: 'GR',
            city: '',
            area: '',
            municipality: '',

            longitude: '',
            latitude: '',
            network_id: null,
            operating_hours_update_type: 'manual',
            operhours_weekly_schedule: [
                {
                    "weekday": "sunday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                },
                {
                    "weekday": "monday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                },
                {
                    "weekday": "tuesday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                },
                {
                    "weekday": "wednesday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                },
                {
                    "weekday": "thursday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                },
                {
                    "weekday": "friday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                },
                {
                    "weekday": "saturday", 
                    "endtime": '00:00',                     
                    "location": null, 
                    "starttime": '00:00', 
                    "ignore_sync": null,
                    "calc_potential_capacity": 0
                }
                
            ],
            extra_info: null,
            // description: '',
            // contact_name: '',
            // contact_email: '',
            // contact_phoneno: '',
            crud_code: '',
            disabled: false,
            //ui mechanics      
            createMode: false,                  
            invitationFormValid: true,
            editFormValid: true,
            editFormBValid: true,
            brand_to_add: '',
            //error
            loading: false,
            loadingNearbyPlaces: false,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            //reference data
            networkOptions: [],
            brand_list_items: [],                                    
            roles_list_items: [
                        {
                            selectvalue: "admin",
                            selecttext: "Admin",
                        },
                        {
                            selectvalue: "viewer",
                            selecttext: "Viewer",
                        },
                        {
                            selectvalue: "designer",
                            selecttext: "Designer",
                        },
                        {
                            selectvalue: "dev",
                            selecttext: "Developer",
                        },
                        {
                            selectvalue: "sysadmin",
                            selecttext: "System Admin",
                        }
                    ],
            firstNameRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)   
            ],
            codeRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)  
            ],
            requiredRules: [
                fieldNotEmpty                
            ],
        }
    },
    computed: {
        selected_brands() {     
            if(this.brand && this.brand_list_items) {
                const rslt = this.brand_list_items.filter(i=> this.brand.includes(i.code));                
                if(rslt) {
                    return rslt;
                }                                           
            }                   
            return [];
        },
        selected_brands_descr() {     
            if(this.brand && this.brand_list_items) {
                const rslt = this.brand_list_items.filter(i=> this.brand.includes(i.code));                
                if(rslt) {
                    return rslt.map(i=>i.title).join(', ');
                }                                           
            }                   
            return "";
        },
        status() {
            return (this.disabled) ? "Disabled" :
                    (this.invitation_code) ? "Invited" :
                    (this.activation_date === "" || this.activation_date == null) ? "Awaiting Activation" : "Active";                    
        },
        canFetchNearbyPlaces() {
            return !this.createMode && !!this.crud_code &&
                this.latitude !== '' && this.latitude != null &&
                this.longitude !== '' && this.longitude != null;
        },
        displayExtraInfo() {
            if(this.extra_info == null) {
                return 'No Extra Info';
            }
            const { nearby_places_data, ...rest } = this.extra_info;
            return JSON.stringify(rest, null, 6);
        }
    },
    async created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;       
            this.createMode = false;     
        }
        else {            
            this.createMode = true;
        }
        const rsp = await api.adpoint.getInitData();
        this.networkOptions.push(...rsp.data.networkOptions);        
    },
    async mounted() {
        // const rsp = await api.brand.getAll();            
        // this.brand_list_items = rsp.data.map(i=> {return {...i, selectvalue: i.code, selecttext: i.title}});
        if(this.crud_code && this.crud_code != '' ){
            const rspB = await api.location.getOne(this.crud_code);
            if(rspB && rspB.data) {
                this.code = rspB.data.code;
                this.title = rspB.data.title;
                this.network_id = rspB.data.network_id;
                this.operating_hours_update_type = rspB.data.operating_hours_update_type;
                this.extra_info = rspB.data.extra_info;

                this.address = rspB.data.extra_info.address;
                this.tk = rspB.data.extra_info.tk;
                this.country = rspB.data.extra_info.country;
                this.city = rspB.data.extra_info.city;
                this.area = rspB.data.extra_info.area;
                this.municipality = rspB.data.extra_info.municipality;
                
                this.latitude = rspB.data.latitude;
                this.longitude = rspB.data.longitude;
                this.operhours_weekly_schedule.splice(0, this.operhours_weekly_schedule.length);
                this.operhours_weekly_schedule.push(...rspB.data.operhours_weekly_schedule);
                //this.description = rspB.data.description;


                // this.contact_name = rspB.data.contact_name;
                // this.contact_email = rspB.data.contact_email;
                // this.contact_phoneno = rspB.data.contact_phoneno;            
            }
        }        
        //this.editFormValid = true;
    },
    methods: {
        // addSelectedBrand() {
        //     if(!this.brand) {
        //         this.brand = [];
        //     }
        //     if(!this.brand.includes(this.brand_to_add)){
        //         this.brand.push(this.brand_to_add);                
        //     }
        //     this.brand_to_add = "";            
        // },
        // removeBrand(b){
        //     for(var i = 0; i < this.brand.length; i++){             
        //         if ( this.brand[i] === b) {             
        //             this.brand.splice(i, 1); 
        //         }            
        //     }
        // },
        generateTimeIntervals() {
            const intervals = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 5) {
                    const hour = h.toString().padStart(2, '0');
                    const min = m.toString().padStart(2, '0');
                    intervals.push(`${hour}:${min}`);
                }
            }
            return intervals;
        },
        save() {
            this.error = '';     
            this.$refs.editForm.validate();     
            this.$refs.editFormB.validate();                     
            if(!this.editFormValid || !this.editFormBValid) {                
                this.snackbarColor = "red";
                this.snackbarMessage = "There are invalid fields.";
                this.snackbar = true;
                return;
            }                                
            this.loading = true;   
            if(this.createMode) {
                api.location.create({      
                    code: this.code,                          
                    title: this.title,
                    operating_hours_update_type: this.operating_hours_update_type,
                    //extra_info: this.extra_info,
                    latitude: this.latitude,
                    longitude: this.longitude,
                    network_id: this.network_id,
                    operhours_weekly_schedule: this.operhours_weekly_schedule,

                    address: this.address,
                    tk: this.tk,
                    country: this.country,
                    city: this.city,
                    area: this.area,
                    municipality: this.municipality,

                    // contact_name: this.contact_name,
                    // contact_email: this.contact_email,
                    // contact_phoneno: this.contact_phoneno,                
                })
                .then((rsp)=>{      
                    if(rsp.data?.extra_info) {
                        this.extra_info = rsp.data.extra_info 
                    }                                  
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;  
                    this.$router.push("/mng/adpoints/location/");
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }  
            else {
                api.location.update(this.crud_code, {                                
                    title: this.title,
                    //description: this.description,
                    network_id: this.network_id,
                    operating_hours_update_type: this.operating_hours_update_type,
                    //extra_info: this.extra_info,
                    latitude: this.latitude,
                    longitude: this.longitude,
                    operhours_weekly_schedule: this.operhours_weekly_schedule,

                    address: this.address,
                    tk: this.tk,
                    country: this.country,
                    city: this.city,
                    area: this.area,
                    municipality: this.municipality,

                    // contact_name: this.contact_name,
                    // contact_email: this.contact_email,
                    // contact_phoneno: this.contact_phoneno,                
                })
                .then((rsp)=>{         
                    if(rsp.data?.extra_info) {
                        this.extra_info = rsp.data.extra_info 
                    }                         
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;  
                    //this.$router.push("/mng/adpoints/location/");
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }                 
        },
        async fetchNearbyPlaces() {
            if(!this.canFetchNearbyPlaces || this.loadingNearbyPlaces) {
                return;
            }
            this.loadingNearbyPlaces = true;
            try {
                const rsp = await api.location.refreshNearbyPlaces(this.crud_code);
                if(rsp?.data) {
                    if(rsp.data.extra_info) {
                        this.extra_info = rsp.data.extra_info;
                    }
                    if(rsp.data.latitude) {
                        this.latitude = rsp.data.latitude;
                    }
                    if(rsp.data.longitude) {
                        this.longitude = rsp.data.longitude;
                    }
                }
                this.snackbarColor = "green";
                this.snackbarMessage = "Nearby places updated.";
            }
            catch(error) {
                this.snackbarColor = "red";
                this.snackbarMessage = error?.response?.data?.message || "Failed to update nearby places.";
            }
            finally {
                this.loadingNearbyPlaces = false;
                this.snackbar = true;
            }
        }       
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}
</style>
